import React from "react";

const Loader = ({ size = 40, color = "#F59E0B" }) => {
    return (
        <div style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative"
        }}>
            <svg
                width={size}
                height={size}
                viewBox="0 0 50 50"
                style={{
                    animation: "rotateLoader 1.2s infinite linear"
                }}
            >
                <circle
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke={color}
                    strokeWidth="4"
                    strokeDasharray="90, 150"
                    strokeLinecap="round"
                />
            </svg>
            <style>
                {`
                    @keyframes rotateLoader {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
        </div>
    );
};

export default Loader;
